<template>
  <div  class="product imgTOP-current header-90">
      <div  class="top-img">
        <img class="mobile_hide" src="../assets/images/product-banner.png" alt="">
        <div class="info-box">
          <div class="title-box">
            <h2>{{nameEN}}</h2>
            <h3 v-if="$i18n.locale!='en'">{{name}}</h3>
          </div>
        <!--  <div class="bannerImage">
            <img :src="bannerImage" alt="">
          </div>-->
        </div>
      </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="product-title">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em>/</em>
          <span>{{name}}</span>
        </div>
        <div class="nav mobile_hide">
          <h4  :class="{'en-font-28':locale=='EN'}">{{$t('ESG_00')}}</h4>
          <ul>
            <li v-for="(item,index) in typeList" :key="index" @click="tabtitle(item.id, item.name, item.bannerImage)" :class="{ active: paramId == item.id }" class="box">
              <a v-if="(item.name) =='慈善基金會'"><a href="setAim">{{item.name}}</a></a>
              <a v-else :class="{'en-font-18':locale=='EN'}">{{item.name}}</a><em class="nav-line"></em>

            </li>
          </ul>
        </div>
        <div class="type-nav pc_hide" v-if="typeList.length > 0">
          <vue-tab-select v-model="paramId" :list="typeList" :title="'ESG_00'" :keyName="'id'" @valueChanged="changeType"></vue-tab-select>
        </div>
        <div class="product-show">
          <ul>
        <span v-if="this.name =='利害關係人'||this.name =='Stakeholders'||this.name =='利害关系人'">


			<h3>{{$t('ESG_02')}}</h3>
			<div class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">

				<p>{{$t('ESG_001')}}</p>
				<br />

        <h5>{{$t('ESG_001_1')}}</h5>
        <p>{{$t('ESG_001_2')}}</p>
         <br />

				<h5>{{$t('ESG_002')}}</h5>
        <p>{{$t('ESG_0021')}}</p>
        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">

            <img style="max-width:100% ;" src="../assets/images/利害關係人溝通01EN.jpg" alt="">
            <img style="max-width:100% ;" src="../assets/images/利害關係人溝通02EN.jpg" alt="">
            <br><br>
              <h5>Sustainability Topics Questionnaire</h5>
              <p>Ba Fang Yun Ji looks forward to maintaining communication with all friends who support and care about the company through various channels, discussing topics such as corporate governance, the environment, and social issues. We sincerely invite you to fill out the "Sustainability Topics Questionnaire" form, which will serve as a reference for Ba Fang Yun Ji in promoting corporate social responsibility and sustainable development. The collected data will only be used for analyzing key issues and will not be used for any other purposes. Please kindly take about 5 minutes of your time to assist us in completing the following questionnaire. Thank you for your support!</p>
              <p><a href="https://forms.gle/SBwzxsjxg1oNaRid7" target="_blank">https://forms.gle/SBwzxsjxg1oNaRid7</a></p>
              <br> <h5>Contact Information:</h5>
              <table class="table-bordered" cellspacing="5" cellpadding="5" style="width:100%;">
                  <tr><td>Employees</td><td>Contact Person: HR Department Specialist<br>
        Employee Complaint Hotline: 0958-509-288<br>
        Employee Complaint Email: obey.laws@8ways.com.tw

                </td></tr>
                  <tr><td>Consumers<br>
                          Franchisees<br>
                          Community Residents<br>
                          Suppliers

                </td><td>Contact Person: PR and Customer Service Division Specialist<br />
                  Customer Service Hotline: 0800-898-000<br />
                <a href="https://www.8way.com.tw/contactUs" target="_blank">Feedback Email </a><br />
                <a href="https://www.instagram.com/bafangtw/?igsh=NTdsZXlsbGY1YnF0" target="_blank">Instagram</a>
                </td></tr>

                  <tr><td>Investors<br />
                          Shareholders<br />
                          Regulatory Authorities

                </td><td>Spokesperson: Lin, Hsin-Yi, Chairperson and President<br />
                  Deputy Spokesperson: Huang, Lee-Chi, Chief Financial Officer<br />
                  Phone: 02-88098898<br />
                  Email: IR@8way.com.tw
                </td></tr>
              </table>

        </span>

      <span v-else>
          <img style="max-width:100% ;" src="../assets/images/利害關係人溝通01TW.jpg" alt="">
          <img style="max-width:100% ;" src="../assets/images/利害關係人溝通02TW.jpg" alt="">
          <br><br>
          <h5>永續議題問卷</h5>
            <p>八方雲集期待透過多元管道，與所有支持與關心八方雲集的朋友們持續溝通公司治理、環境、社會等面相議題，誠摯邀請您填寫「永續議題問卷」表單 ，讓八方雲集得以做為推動企業社會責任及永續發展的參考，所蒐集之資料僅作為八方雲集重大議題分析之用，不作為其他用途，敬請撥冗約5分鐘時間，協助我們填寫以下問卷，感謝您的協助!</p>
          <p><a href="https://forms.gle/SBwzxsjxg1oNaRid7" target="_blank">https://forms.gle/SBwzxsjxg1oNaRid7</a></p>
          <br> <h5>聯絡方式:</h5>
          <table class="table-bordered" cellspacing="5" cellpadding="5" style="width:100%;">
            <tr><td>員工</td><td>聯絡窗口：人力資源處<br />
          員工申訴專線：0958-504-288<br />
          員工申訴信箱：obey.laws@8ways.com.tw<br />
          </td></tr>
            <tr><td>消費者<br />
          加盟主<br />
          社區居民<br />
          供應商
          </td><td>聯絡窗口：公關客服處專人<br />
          客服專線：0800-898-000<br />
          <a href="https://www.8way.com.tw/contactUs" target="_blank">意見信箱</a><br />
          </td></tr>

            <tr><td>投資人<br />
          股東<br />
          主管機關<br />
          </td><td>發言人：林欣怡 董事長兼總經理<br />
          代理發言人：黃莉淇 財務長<br />
          電話：02-88098898<br />
          信箱：IR@8way.com.tw
          </td></tr>
           </table>

      </span>

        </div>   </div>   </div>   </div>

      </span>

    <span v-if="this.name =='永續發展'||this.name =='Sustainability'||this.name =='永续发展'">


			<h3>{{$t('ESG_03')}}</h3>

      <div class="about-box-01">
        <div class="left">
              <div class="titleBox ">
                <div class="description">
                  <h3>●{{$t('ESG_01')}}</h3><br>
                  <p>{{$t('ESG_003')}}</p>

                  <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"> </span>
                  <span v-else><a href="https://www.8way.com.tw/investor/0703">請見官網永續發展暨風險管理委員會</a> </span>               
<br>
                  <p>{{$t('ESG2021')}}</p>

                   <div >
                    <p>- {{$t('ESG_0030')}}</p>
                    <p>- {{$t('ESG_0031')}}</p>
                    <p>- {{$t('ESG_0032')}}</p>
                    <p>- {{$t('ESG_0033')}}</p>
                    <!-- <a href="../../static/files/SustainabilityReport_2021.pdf" target="_blank"><img style="max-width:100% ;" src="../assets/images/ESGS2021.png" alt=""></a> -->
                    <p>- {{$t('ESG_0034')}}</p>
                    <br><br>
                    <p>{{$t('ESG2022')}}</p>
                    <p>- {{$t('ESG_0035')}}</p>
                    <p>- {{$t('ESG_0036')}}</p>
                    <p>- {{$t('ESG_0037')}}</p>
                    <p>- {{$t('ESG_0038')}}</p>
                    <br><br>
                    <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">- Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies</p>
                    <p v-else>- 111年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</p>
   <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE TPEx Listed Companies.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies</a></p>
			<p v-else><a  href="../../static/files/2022年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">111年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</a></p>
    <br>
    <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
    <p>2023</p>
    <p>- In 2023,  obtained  a total of 63 solar energy certificates</p>
    <a  href="https://www.trec.org.tw/en/transaction_history?search=Bafang&year=2023&perPage=10" target="_blank"><img style="max-width:100% ;" src="../assets/images/solar240130EN.jpg" alt=""></a>
    <p>Above information is accepting from National Renewable Energy Certification Center(<a href="https://www.trec.org.tw/en/transaction_history?search=Bafang&year=2023&perPage=10" target="_blank">https://www.trec.org.tw/certification</a>)</p>
    </span>
    <span v-else>
    <p>112年</p>
    <p>- 112年度太陽能發電憑證112年度共取得68張</p>
    <a  href="https://www.trec.org.tw/certification" target="_blank"><img style="max-width:100% ;" src="../assets/images/solar24314TW.png" alt=""></a>
    <p>以上資訊連結至國家再生能源憑證中心(<a href="https://www.trec.org.tw/certification" target="_blank">https://www.trec.org.tw/certification</a>)</p>
    <p>每張憑証為1000度，111年電力排碳係數為0.495公斤CO2e/度</p>
    <p>故可減少0.495公斤CO2e/度*1000度*68張=33,660公斤的CO2排放量</p>
    </span>

    <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
    <p>- Published the 3rd ESG Report</p>
    <p>-The 2023 Sustainability Report was approved by the Board of Directors on August 7, 2024.</p>
    <p>- Published the 3rd ESG Report in English</p>
    </span>
    <span v-else>

    <p>- 112年永續報告書經113年8月7日董事會討論決議通過</p>
    <p>- 發布第3本永續報告書</p>
    <p>- 發布第3本英文永續報告書</p>
    </span>
    <br>
    <p>-{{$t('ESG_0039')}}</p>
    <p><a  href="" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">{{$t('ESG_0039')}}</a></p>
    <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">- Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies in 2023</p>
    <p v-else>- 112年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</p>
   <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/FulfillmentofESGandDeviationsfromtheSustainableDevelopmentBestPracticesforTWSETPExListedCompaniesin2023.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSETPEx Listed Companies in 2023</a></p>
			<p v-else><a  href="../../static/files/112年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">112年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</a></p>
    <br>

    <br>
    <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
    <p>-2024</p>
    <p>Green Bond Investments</p>
    <p>In 2024, Bafang Yunji invested NT$9,780,000 in the Green Bond of First Commercial Bank (Bond Name: P10 First Bank 1, Code: G159A3), with a face value of NT$10 million. This bond has been certified by the Greener Bond Qualification Program at the Taiwan OTC Securities Exchange.</p>
    <br> <p>-Implementation of Social Welfare in 2024</p>
    <p><a  href="../../static/files/ImplementationofSocialWelfarein2024.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Implementation of Social Welfare in 2024</a></p>

    <br> <p>-Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies in 2024</p>
    <p><a  href="../../static/files/2024Fulfillment of ESG and_EN.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies in 2024</a></p>
      
    <br> <p>-2025</p>
    <br> <p>Green Bond Investment</p>
    <br> <p>In 2025, Bafang Yunji invested NT$9,941,000 (par value NT$10,000,000) in a green bond issued by First Commercial Bank Co., Ltd. (bond short name: P10 First Bank 1; code: G159A3). The bond has obtained green bond qualification certification from the Taipei Exchange (TPEx).</p>
    <br> <p>-Implementation of Social Welfare in 2025</p>
    <p><a  href="../../static/files/Implementation of Social Welfare in 2025.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Implementation of Social Welfare in 2025</a></p>
      
    
    </span>
    <span v-else>
        <p>-113年</p>
        <p>綠色債券投資</p>
        <p>八方雲集113年投資第一商業銀行股份有限公司綠色債券(債券簡稱:P10一銀1，代碼：G159A3)新台幣9,780,000元整(面額1,000萬元整)，該債券取得櫃檯買賣中心綠色債券資格認可。</p>
        <p>-113年永續報告書經114年8月12日董事會討論決議通過</p>
        <p>-發布第4本永續報告書</p>
        <p>-發布第4本英文永續報告書</p>

      <br> <p>-113年社會公益執行情形</p>
        <p><a  href="../../static/files/113年社會公益執行情形.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">113年社會公益執行情形</a></p>
      
      <br> <p>-113年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</p>
        <p><a  href="../../static/files/202永續發展實務守則差異情形及原因.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">113年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</a></p> 
      
      <br> <p>-114年</p>
           <p>綠色債券投資</p>
           <p>八方雲集114年投資第一商業銀行股份有限公司綠色債券(債券簡稱:P10一銀1，代碼：G159A3)新台幣9,941,000元整(面額1,000萬元整)，該債券取得櫃檯買賣中心綠色債券資格認可。</p>
      <br> <p>-114年社會公益執行情形</p>
        <p><a  href="../../static/files/114年社會公益執行情形.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">114年社會公益執行情形</a></p>

  </span>
    </div><br>
    <br>  

      <h4>●{{$t('ESG_05')}}</h4>
          <span v-if="locale=='EN'">
              <img style="max-width:100% ;" src="../assets/images/SustainabilityReport_2024_cover_EN.jpg" alt="">
              </span>
              <span v-else>
               <img style="max-width:100% ;" src="../assets/images/SustainabilityReport_2024_cover_TW.jpg" alt=""> 
          </span>

        <div class="dotted-box">

          <div class="dotted-line">    <!-- 113年 -->
          <span v-if="locale=='EN'">
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2024EN.pdf" target="_blank">2024 Download Sustainability Report</a>
                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/ASustainabilityReport_2024TW.pdf" target="_blank">下載113年永續報告書</a>
                </div>
          </span>
        </div>   


        <div class="dotted-line">    <!-- 112年 -->
          <span v-if="locale=='EN'">
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2023E.pdf" target="_blank">2023 Download Sustainability Report</a>
                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2023TW.pdf" target="_blank">下載112年永續報告書</a>
                </div>
              </span>
        </div>    

        <div class="dotted-line">    <!-- 111年 -->
          <span v-if="locale=='EN'">
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2022E.pdf" target="_blank">{{$t("company_23_4")}}</a>
                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2022.pdf" target="_blank">{{$t("company_23_4")}}</a>
                </div>
              </span>

        </div> 

        <div class="dotted-line">    <!-- 110年 -->
          <span v-if="locale=='EN'">
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2021E.pdf" target="_blank">{{$t("company_23_3")}}</a>
                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <a href="https://www.8way.com.tw/static/files/SustainabilityReport_2021.pdf" target="_blank">{{$t("company_23_3")}}</a>
                </div>
              </span>
        </div>

              <br><br>
              <div >
              <span v-if="locale=='EN'">
                <div class="moreLink">
                  <h3>●Sustainable Risk Management</h3><br>
                  <p>The Company focuses on international sustainability standards and regulations as well as industry development trends. Based on the materiality principle, the Company conducts impact identification and assessment of environmental, social, and governance (ESG) issues that are of high concern to stakeholders and have significant impacts on the Company’s operations, and accordingly formulates relevant goals and management policies.(For detailed information, please refer to the 2024 Sustainability Report – Section II. Material Topics and Stakeholders.)</p><br>
                  <h5>Risk Management Policy and Strategy</h5>
                  <p>The Company has established the Sustainable Development and Risk Management Committee (formerly the Risk Management Committee) under the Board of Directors. Through existing departments or designated risk responsibility units, the Company conducts risk management for the operational processes under their respective responsibilities. In accordance with the “Risk Management Policy and Procedures,” the Company carries out risk identification, analysis, evaluation, response, and monitoring and review mechanisms.The status of risk management implementation was reported to the Board of Directors on November 11, 2025.(For detailed information, please refer to the <a href="https://www.8way.com.tw/investor/0703">Sustainable Development and Risk Management</a> Committee section on the Company’s official website.)</p>
                  <br><br>
                  <h3>●Sustainable Supplier Management</h3><br>
                  <p>Ba Fang Yun Ji is committed to food safety and environmental sustainability through green procurement, placing great emphasis on food safety and environmental protection. These factors are key considerations when selecting suppliers. To effectively manage supplier quality control, delivery timelines, costs, and compliance with relevant regulations, Ba Fang Yun Ji has established the Supplier Evaluation and Audit Management Guidelines. The supplier evaluation system is used to manage suppliers, with audit items including environmental waste management, farm environmental management, safety and health management, and packaging safety management, all aimed at promoting supplier practices in environmental protection and safety and health management.
                  <br />
                  The evaluation scores serve as a basis for assessing supplier risk levels and guide procurement decisions for the following year. From 2021 to 2024, all major suppliers were evaluated as excellent suppliers, with no non-compliant suppliers. Additionally, the number of supplier evaluations has increased year by year, ensuring the selection of high-quality cooperation partners through a process of continuous improvement.
                  </p>
                  <br><br>

                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <h3>●永續風險管理</h3><br>
                  <h5>依循重大性原則之風險評估</h5>
                  <p>本公司關注國際永續標準與規範、產業發展趨勢，以利害關係人高度關注、對公司營運衝擊影響顯著之重大性原則進行環境、社會及公司治理等議題的衝擊鑑別評估，訂定目標與管理方針。(詳細資訊請參閱2024永續報告書- II.重大主題與利害關係人)</p><br>
                  <h5>風險管理政策及策略</h5>
                  <p>本公司於董事會轄下設置永續發展暨風險管理委員會(原風險管理委員會)，並透過組織現有部門或風險職責單位針對其負責之作業流程進行風險管理，依據「風險管理政策與程序」，進行辨識、分析、評量、回應及監督與審查機制，已於114年11月11日向董事會報告風險管理執行情形。 <a href="https://www.8way.com.tw/investor/0703">(詳細資訊請參閱官網之永續發展暨風險管理委員會)</a></p>
                  <br><br>
                  <h3>●永續供應商管理</h3><br>
                  <p>八方雲集致力食品安全與環境永續之綠色採購、重視食品安全與環保，以此為列為採納供應商的重要選項。為有效管理供應商之品質控制、交期、成本及符合相關法規等規範，以共創供應商與八方雲集雙贏之契機，八方雲集訂有《供應商評鑑及稽核管理辦法》，依據供應商評鑑制度進行供應商管理，評鑑之稽核項目包含環保廢棄物管理、農場環境管理、安全衛生管理、包材安全管理等項目，以促進供應商環保及安全衛生管理作為。供應商評鑑結果分數作為供應商風險高低之依據，作為來年調整供應商採購決策的依據。110年至113年主要供應商的評鑑皆為優良供應商，尚無不合格的廠商。並且逐年增加執行供應商評鑑家數去蕪存菁，慎選優質合作對象。</p>
                  <br><br>
                  <h3>{{$t('ESG_06')}}</h3><br>
                  <p>{{$t('ESG_06_1')}}</p>
                  <p style="margin-left:2em;padding-right:2em;">{{$t('ESG_06_2')}}</p>
                  <p>{{$t('ESG_06_3')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_4')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_5')}}</p>
                  <p>{{$t('ESG_06_6')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_7')}}</p>
                  <p>{{$t('ESG_06_8')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_9')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_10')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_11')}}</p>
                  <br>

                  <h3>{{$t('ESG_06_12')}}</h3><br> 
                  <p>{{$t('ESG_06_13')}}</p>
                  <p style="margin-left:2em;padding-right:2em;">{{$t('ESG_06_14')}}</p>
                  <p>{{$t('ESG_06_15')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_16')}}</p>
                  <p>{{$t('ESG_06_17')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_18')}}</p>
                  <p><img src="../assets/images/ISO14001.png" width="100%" height="100%"></p>

                  <p>{{$t('ESG_06_19')}}</p>
                  <p style="margin-left:2em;padding-right:2em;">{{$t('ESG_06_20')}}</p>
                  <a  href="../../static/files/112年用水量外部驗證.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">112年用水量外部驗證</a>
                  <br>
                  <a  href="../../static/files/113年用水量外部驗證.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">113年用水量外部驗證</a>
                  <p><img src="../assets/images/水資源統計.jpg" width="100%" height="100%"></p>
        
                  <br> 
                  <h3>{{$t('ESG_06_21')}}</h3><br> 
                  <p>{{$t('ESG_06_22')}}</p>
                  <p style="margin-left:2em;padding-right:2em;">{{$t('ESG_06_23')}}</p>
                  <p>{{$t('ESG_06_24')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_25')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_26')}}</p>
                  <p>{{$t('ESG_06_27')}}</p>
                  <p style="margin-left:2em;padding-right:2em;" >{{$t('ESG_06_28')}}</p>

                </div>

              </span>
              </div>

      </div>
      </div>
      </div>
      </div>
      </div>





    </span>

    <span v-if="this.name =='人權政策'||this.name =='The Human Rights Policy'||this.name =='人权政策'">
      <h3>{{$t('ESG_04')}}</h3>
      <div class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">

        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'">
          <p>{{$t('ESG_077')}}</p><br>

				<p>{{$t('ESG_078')}}</p><br>

				<p>{{$t('ESG_079')}}</p><br>

        <p style="margin-left:1em;padding-right:2em;">● Diverse Employment</p>
        <p style="margin-left:1em;padding-right:2em;">The Company supports and encourages the employment of local talent and gives priority to local residents in its recruitment practices. At the same time, we value cultural diversity among our workforce and provide foreign employees with a friendly working mechanism as well as a safe and healthy working environment. In accordance with labor laws and regulations, the Company has established relevant management measures and strictly implements them. Upon onboarding, employees are provided with detailed explanations of the Employee Work Rules, Prevention, Complaint, and Investigation Procedures for Workplace Misconduct, and are required to sign employment contracts, thereby safeguarding employees’ labor rights and interests.</p>
        <br>
        <p style="margin-left:1em;padding-right:2em;">● Employee Care</p>
        <p style="margin-left:1em;padding-right:2em;">1.Welfare Measures: </p>
        <p style="margin-left:1em;padding-right:2em;">In accordance with regulations, the Company has established an Employee Welfare Committee and allocates welfare funds to provide various employee benefits, including subsidies for employee travel and health checkups, gifts or allowances for Parents’ Day, birthday gifts, and other welfare measures. To protect employees’ rights and enhance cohesion, the Company also offers diverse benefits such as marriage gifts, congratulatory gifts for employees’ children upon marriage, childbirth subsidies, children’s education subsidies, and bereavement allowances for employees and their family members.</p>
        <br>
        <p style="margin-left:1em;padding-right:2em;">2.Emergency Assistance: </p>
        <p style="margin-left:1em;padding-right:2em;">A portion of the funds of the Bafang Yunji Social Welfare and Charity Foundation (New Taipei City) is designated for employee emergency assistance, providing timely support to employees facing unexpected difficulties and helping them overcome hardships.</p>
        <br>
        <p style="margin-left:1em;padding-right:2em;">● Safe and Friendly Working Environment</p>
        <p style="margin-left:1em;padding-right:2em;">1.Occupational Safety and Health </p>
        <p style="margin-left:1em;padding-right:2em;">The Company complies with applicable occupational safety and health laws and regulations, as well as other commitments, to safeguard workers’ safety and health. We continuously identify hazards, assess risks, and seize improvement opportunities, and implement effective preventive and control measures to provide a safe and healthy working environment and reduce the occurrence of occupational accidents.</p>
        <p style="margin-left:1em;padding-right:2em;">2.Specific Measures:</p> 
        <p style="margin-left:1em;padding-right:2em;">The Company provides appropriate education and training, establishes sound communication and consultation channels, and encourages workers and stakeholders to jointly promote company policies to enhance awareness of occupational safety and health management. Employees are guided to actively propose improvement suggestions and participate in decision-making processes, thereby strengthening overall participation and a sense of responsibility. Senior management is committed to providing the necessary resources and leadership support, and through goal management, performance monitoring, management reviews, and continuous improvement, ensures continual enhancement of occupational safety and health performance to achieve sustainable operations.</p>
        <br>
        <p style="margin-left:1em;padding-right:2em;">3.Outsourced Periodic Inspections:</p>
        <p style="margin-left:1em;padding-right:4em;">• Annual fire safety inspection and reporting: once per year</p>
        <p style="margin-left:1em;padding-right:4em;">• Self-defense fire brigade training at each plant: once every six months</p>
        <p style="margin-left:1em;padding-right:4em;">• Annual inspection of high- and low-voltage electrical systems: once per year</p>
        <p style="margin-left:1em;padding-right:4em;">• Annual inspection of high- and low-voltage electrical systems: once per year</p>
        <br>
        <p>In addition, the Company obtained ISO 45001 Occupational Health and Safety Management System certification in 2025, with the certification period from November 13, 2025 to November 12, 2028.</p>
        <img src="../assets/images/ISO45001_EN.png" width="100%" height="100%">

        <br>
        <p style="margin-left:2em;padding-right:2em;">● Human Rights Due Diligence</p>
        <p  style="margin-left:2em;padding-right:2em;">Bafang Yunji formulated its Human Rights Policy in 2022, with key focuses including diversity and inclusion and ensuring equal employment opportunities, smooth communication channels, strict compliance with labor-related laws and regulations, the provision of a safe and friendly working environment, non-discrimination, and the regular review and assessment of human rights–related systems and practices. Once risks are identified through assessment, corresponding risk mitigation measures are promptly formulated, and the effectiveness of such measures is reviewed on a regular basis. In addition, internal audits and employee feedback surveys are conducted to ensure the effective implementation of the policy.In 2025, the Company did not record any discrimination incidents.</p>
        <p  style="margin-left:2em;padding-right:2em;">● Employee Opinion Survey (Employee Engagement Survey)</p>
        <p  style="margin-left:2em;padding-right:2em;">In October 2025, the Company conducted its annual Employee Engagement Survey among all employees of Bafang Yunji International Co., Ltd. to understand employees’ perspectives on work engagement, organizational relationships, and the working environment. The survey coverage rate reached 85.5% in 2025, representing an increase of 16.5% compared to the previous survey.</p>
        <p  style="margin-left:2em;padding-right:2em;">The results showed that the Company achieved an average employee agreement score of 82.7%, indicating a medium-to-high satisfaction and stable range, with employees generally expressing positive recognition of the Company. The highest levels of satisfaction were observed in organizational climate and direct supervisors’ management style, reflecting broad employee recognition of the Company’s cultural foundation and leadership effectiveness, and demonstrating tangible progress in strengthening employee cohesion.The Company also identified compensation and incentives, learning and career development, and working environment and facilities as priority areas for improvement. Corresponding improvement plans have been formulated, and their effectiveness is expected to be tracked by the end of 2026.</p>
        <br>
        <h4>Customer Feedback Management</h4>
        <p style="margin-left:2em;padding-right:2em;">● Customer Rights Policy</p>
        <p style="margin-left:2em;padding-right:2em;">Since its establishment, the Company has consistently adhered to a unified business philosophy to provide delicious and safe products, while also striving to deliver a high-quality service experience to customers. All customer service teams receive professional and comprehensive internal training and are equipped with professional knowledge, a sincere attitude, and patience. Guided by the principles of “sincerity, respect, and care,” we serve every customer with dedication. We firmly believe that the foundation of sustainable corporate and brand development lies in the continued support and recognition of consumers and customers toward Bafang Yunji.</p>
        <p style="margin-left:2em;padding-right:2em;">● Building Comprehensive Customer Satisfaction – Customer Complaint Handling Procedures</p>
        <p style="margin-left:2em;padding-right:2em;">Through the continuous enhancement and optimization of customer service processes, the Company incorporates warmth and care into its established standard operating procedures to create a comprehensive customer service experience that satisfies consumers and customers. Customer feedback serves as our greatest driving force for improvement. By continuously reviewing, improving, and identifying issues, we are able to develop service models that better meet customer needs.The Company has established the “Customer Complaint Handling Procedures.” When the customer service unit receives a consumer complaint, it completes a Consumer Complaint Handling Record Form based on the nature of the complaint and registers the case accordingly. In the event of a major complaint, the Company immediately reports the matter and dispatches personnel to the store for investigation and follow-up handling. Complaint samples are retrieved and transferred to the food safety unit for abnormal analysis and assessment. After the root cause is identified, the responsible unit implements corrective and preventive measures, and mystery shopper visits are arranged to verify the effectiveness of the improvements.</p>
        <p style="margin-left:2em;padding-right:2em;">● Listening to Consumers’ Voices – Complaint Handling Channels</p>
        <p style="margin-left:2em;padding-right:2em;">The Company listens to consumers through multiple channels, including the opinion mailbox on the official website, email, and a toll-free 0800 hotline. A rigorous service process has been established, whereby the customer service department categorizes and records feedback received from various channels on a daily basis, documents the entire handling process, resolves customer concerns, and promptly shares the information with business units and central factory departments for reference.</p>
        <p style="margin-left:2em;padding-right:2em;">● Regular Review and Analysis of Customer Complaint Feedback</p>
        <p style="margin-left:2em;padding-right:2em;">The public relations and customer service unit regularly compiles and analyzes customer complaint cases to facilitate review and evaluation by relevant departments, and to formulate corrective and preventive measures.Listening to customers’ voices and responding to their feedback not only makes customers feel valued, but also highlights the dedication of the customer service team and demonstrates the Group’s responsible and receptive attitude toward constructive suggestions. In the digital era, prompt customer service response and remediation can turn potential crises into opportunities and help accumulate positive brand reputation and goodwill.</p>
        <br>
        <h4>Environmental Management</h4>
        <p style="margin-left:2em;padding-right:2em;">● Environmental Management Policy</p>
        <p style="margin-left:2em;padding-right:2em;">In October 2025, the Company formulated the Environmental, Safety, and Energy Management Policy, incorporating environmental protection as a core policy focus. By identifying significant environmental impacts and sources of energy consumption, we continue to promote pollution prevention, energy conservation and carbon reduction, waste reduction, and resource recycling and reuse. In response to climate change, we advance carbon inventory and carbon reduction initiatives to move toward a net-zero transition.</p>
        <p style="margin-left:2em;padding-right:2em;">● Environmental Management System and Implementation Status in 2025</p>
        <p style="margin-left:2em;padding-right:2em;">In accordance with environmental regulations issued by the Ministry of Environment, the Company has established the Environmental and Occupational Safety and Health Management Manual and relevant ISO management procedures, and continues to implement environmental management programs. In 2025, the Company carried out environmental management initiatives, including perimeter noise monitoring for noise control and waste reduction measures, such as implementing electronic approval forms to reduce paper waste.</p>
        <p style="margin-left:2em;padding-right:2em;">● ISO 14001 Certification Status</p>
        <p style="margin-left:2em;padding-right:2em;">The Company’s Tamsui Plant conducted ISO 14001 training and launched the project implementation in July 2025. A total of 24 employees obtained ISO 14001 internal auditor training certificates. The Plant successfully passed certification and obtained the ISO 14001 certificate in November 2025, with a validity period from November 13, </p>
        <img src="../assets/images/ISO14001_EN.png" width="100%" height="100%">
        <p style="margin-left:2em;padding-right:2em;">● Water Resource Statistics</p>
        <p style="margin-left:2em;padding-right:2em;">In the food manufacturing industry, the production process—from raw material preparation to actual processing—relies heavily on a stable supply of water resources. In recent years, as the impacts of climate change have become increasingly evident, water resource management and water-use efficiency have gradually become key issues of concern for both internal and external stakeholders of Bafang Yunji. The Company’s water consumption (water withdrawal) for 2023 and 2024 has been externally verified.</p>
        <a style="margin-left:2em;padding-right:2em;" href="../../static/files/External Verification of Water Consumption in 2023.pdf" target="_blank">External Verification of Water Consumption in 2023</a>
        <br>
        <a style="margin-left:2em;padding-right:2em;" href="../../static/files/External Verification of Water Consumption in 2024.pdf" target="_blank">External Verification of Water Consumption in 2024</a>
        <img src="../assets/images/Water Resource Statistics.jpg" width="100%" height="100%">        
        
        <br>
        <h4>Energy Management</h4>
        <p style="margin-left:2em;padding-right:2em;">● Energy Management Policy</p>
        <p style="margin-left:2em;padding-right:2em;">In October 2025, the Company formulated the Environmental, Safety, and Energy Management Policy, incorporating energy management as one of its core policy elements. By identifying significant environmental impacts and sources of energy use, the Company continues to promote pollution prevention, energy conservation and carbon reduction, waste reduction, and resource recycling and reuse. In addition, the Company implements energy-efficient design principles and gives priority to the procurement of energy-efficient products and services, thereby gradually enhancing energy management performance.</p>
        <p style="margin-left:2em;padding-right:2em;">● Energy Management Plan and Implementation Status in 2025</p>
        <p style="margin-left:2em;padding-right:2em;">While advancing carbon inventory initiatives, the Company identifies significant sources of energy consumption and sets energy-saving and carbon-reduction targets, and promotes the use of renewable energy to improve energy efficiency and reduce carbon emissions. In 2025, the Company completed carbon inventory for its Taiwan sites, and plans to complete group-wide carbon inventory and establish carbon reduction targets in accordance with regulatory requirements in 2026.</p>
        <p style="margin-left:2em;padding-right:2em;">In 2025, the installed capacity of solar power systems at the Xiluo Plant and Erlun Warehouse of Bafang Yunji reached 99.22 kWp and 177.94 kWp, respectively. From January to October 2025, solar power generation resulted in the acquisition of 91 Renewable Energy Certificates (T-RECs). The Company plans to add an additional 349.77 kWp of installed capacity at its factories in 2026, further increasing total installed green energy capacity and usage.</p>
        <p style="margin-left:2em;padding-right:2em;">● ISO 50001 Certification Status</p>
        <p style="margin-left:2em;padding-right:2em;">The Company’s Tamsui Plant successfully obtained ISO 14001 Environmental Management System certification in November 2025. The Company plans to obtain ISO 50001 Energy Management System certification in 2026, and will continue to optimize its energy management framework.</p>

        </span>
        <span v-else>
          <h4>人權政策</h4>
          <p>本公司致力維護員工基本人權，認同並支持「聯合國全球盟約」、「聯合國世界人權宣言」及「國際勞工組織工作基本原則與權利宣言」等國際公認之人權標準，以實際行動體現本公司尊重與保護人權之責任，遵守公司所在地勞動、性別工作平等相關法規規範，禁止強迫、杜絕任何侵犯及違反人權的行為。本公司的人權政策包含對多元的包容性及確保工作機會均等；遵循勞動法令規範，確保僱用政策無差別待遇且不強迫勞動。禁止年齡歧視，保障中高齡者勞動權益，建構友善就業環境；及不非法僱用童工。</p>
          <p>落實職場多元性，不因員工個人性別(含性傾向)、種族、階級、年齡、婚姻、語言、思想、宗教、黨派、籍貫、出生地、容貌、五官及身心障礙等，而有差別待遇或任何形式之歧視。</p>
          <p style="margin-left:1em;padding-right:2em;">● 確保工作機會均等</p>
          <p style="margin-left:2em;padding-right:2em;">截至114年12月31日，八方雲集台灣地區員工總數為1,135人，其中男性占61.85%，女性占38.15%。除工廠物流同仁因工作性質多為男性之外，其餘各職級之間的性別分布並無顯著差異。所有同仁不論性別、年齡或種族，在內部均享有平等的學習發展機會，有效達到促進性別、就業實質及平等之精神。</p>
          <p style="margin-left:1em;padding-right:2em;">● 多元雇用</p>
          <p style="margin-left:2em;padding-right:2em;">本公司支持並鼓勵在地人才就業，於聘用員工時以在居民為優先考量。同時我們也重視員工的多樣性文化，針對外籍員工提供友善的工作機制及安全健康的工作環境。依據勞動法令規範，我們制定相關管理辦法，積極遵守執行，在員工到職時，詳細說明 《員工工作規則》、《職場不法侵害防治、申訴及調查處理措施》及簽訂聘僱合約書，以保障員工之勞動權益。</p>
          <p style="margin-left:1em;padding-right:2em;">● 員工關懷</p>
          <p style="margin-left:2em;padding-right:2em;">•	福利措施：本公司依規範設立職工福利委員會，並撥付福利基金，用於辦理員工旅遊補助、健康檢查補助、父母親節節金或禮品、生日禮金等各項員工福利措施。為了維護員工權益並增進凝聚力，我們提供多元福利，包括婚嫁禮金、子女結婚賀儀、生育補助、子女教育補助，以及同仁及家屬的喪葬慰問金。</p>
          <p style="margin-left:2em;padding-right:2em;">•	急難救助：「財團法人新北市私立八方雲集社會福利慈善事業基金會」之部分金額指定用途為員工急難救助，在員工遭遇困難時伸出援手協助度過難關。</p>
          <p style="margin-left:1em;padding-right:2em;">● 安全友善的工作環境</p>
          <p style="margin-left:2em;padding-right:2em;">•	職業安全與衛生<br>本公司遵守適用的職安衛法規及其他承諾事項，保障工作者安全與健康。持續鑑別危害、評估風險、掌握機會，採取有效預防與控制措施，提供工作者安全健康的工作環境，降低職業災害發生。</p>
          <p style="margin-left:2em;padding-right:2em;">1.具體措施: 提供適切的教育訓練，建置良好的溝通與諮詢管道，鼓勵工作者及利害關係人共同推動公司政策，提升對職安衛管理的認知；並引導工作者積極提出改善建議、參與決策過程，以增進全員的參與感與責任感。最高管理階層承諾提供必要資源與領導支持，透過目標管理、績效監測、管理審查與持續改善，確保職安衛管理績效持續提升，以達永續經營的目標。
          <p style="margin-left:2em;padding-right:2em;">2.委外定期檢查: 消防年度檢修申報一年一次、各廠自衛消防編組訓練半年一次、高低壓電年度檢查一年一次、作業環境監測半年一次。此外，本公司已於114年取得ISO45001職業安全管理系統認證，起訖時間為 114年11月13日 至 117年11月12日 。
           </p><img src="../assets/images/ISO45001.png" width="100%" height="100%">
          <p style="margin-left:2em;padding-right:2em;">•	利潤與成果分享<br>本公司已於章程明定保留提撥不低於1%之員工酬勞，前述員工酬勞數額中，應提撥不低於40%為基層員工分派酬勞，並制訂「員工酬勞實施辦法」，將經營績效成果反饋於員工。我們在積極招募人才之餘，搭配合理又具吸引力的優質待遇，使八方雲集維持長期競爭力以及員工向心力，並綜合考量同仁績效表現，適時給予晉升或調薪之獎勵。</p>
          <p style="margin-left:2em;padding-right:2em;">•	退休制度與其實施情形<br>本公司依據勞動基準法之規定訂定員工退休辦法，每月按薪資總額提撥退休準備金，存入台灣銀行之退休金專戶，勞工退休金條例自民國94年7月1日起施行，並採確定提撥制後，本公司員工得選擇適用「勞動基準法」有關之退休金規定，或適用該條例之退休金制度並保留適用該條例前之工作年資。對適用該條例之員工，本公司每月負擔之員工退休金提撥率，不低於員工每月薪資百分之六。</p>
          <p style="margin-left:2em;padding-right:2em;">•	定期檢視及評估人權相關制度<br>本公司定期檢視人權管理成效，並按評估結果進行管理措施之優化，降低相關風險。本公司人權政策同步於公司官網公開揭露，提升員工與利害關係人的人權意識，進而持續改進。</p>
          <p style="margin-left:2em;padding-right:2em;">•	勞資間協議與各項員工權益維護措施<br>公司各級主管與員工代表皆定期舉辦勞資會議，除宣傳公司相關政策外，並與員工代表溝通工作相關之建議及福利制度。此外，公司於廠區設有員工意見信箱、專用電子信箱及專線，員工可透過意見信箱、專用電子信箱及專線表達想法或提供建言。透過各項溝通平台，了解員工需求進而改善公司管理規則以力求人性化管理層面。</p>
          <br>
          <h4>人權盡職調查</h4>
          <p>八方雲集已於2022年制定人權政策，其主要重點包括：多元包容性與確保工作機會均等、順暢的溝通管道、恪遵勞動相關法規、提供安全友善的工作環境、不歧視和定期檢視及評估人權相關制度與作為。一旦風險評估確定結果，將立即制定相應的風險減緩措施，隨後定期審核相關措施的實施效果。同時，透過內部稽核及員工反饋調查等途徑進行檢視，以確保政策的有效實施。</p>
          <p style="margin-left:1em;padding-right:2em;">● 人權盡職調查結果及減緩方案</p>
          <p style="margin-left:2em;padding-right:2em;">本公司於114年並未發生任何歧視事件，有關針對潛在的人權風險執行之減緩措施<a href="../../static/files/114人權盡職調查附件.pdf" target="_blank">如附件(PDF)</a></p>
          <h4>員工意見調查(滿意度調查)</h4>
          <p style="margin-left:2em;padding-right:2em;">本公司於114年10月針對八方雲集國際股份有限公司全體同仁進行年度員工意見調查(Employee Engagement Survey)，以期瞭解同仁對工作參與、組織關係及工作環境的看法。114年覆蓋率達85.5%。較前次增加16.5％。結果顯示，全公司員工平均認同度達82.7%，屬中高滿意度/穩定區間，員工普遍認同公司。顯見員工對組織氣氛及認同與直屬主管的管理風格的滿意度最高，這代表公司的文化基石和主管的領導力獲得多數員工肯定，朝向強化員工向心力之努力已達到成果。我們亦識別出【薪酬激勵】、【學習與職涯發展】及【工作環境及設施】為需優先優化的領域，為此，我們已制定改善方案，預計將於 2026 年底追蹤成效。完整檔案請見下方說明文件。</p>
          <a style="margin-left:2em;padding-right:2em;" href="../../static/files/114員工意見調查.pdf" target="_blank">員工意見調查</a>





        </span>

			</div></div></div></div>
      </span>
      <span v-if="this.name =='慈善基金會'||this.name =='Foundation'||this.name =='慈善基金会'">

      <div class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">

                  <p><a href="setAim">{{$t('home_01')}}</a></p>

			</div></div></div></div>
      </span>
    </ul>
    </div>
        </div>
      </div>
    </div>

</template>

<script>
  import API from "./config/api";
  import vueTabSelect from "./default/vue-tab-select";
  export default {
    name: 'ESG',
   metaInfo() {
      let ogTitle = '';
      let ogDescription = '';
      let ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
      let schemaData = null;
      const baseUrl = 'https://www.8way.com.tw';
      let id = this.$route.params.ids || '0901';

      switch(id){
        case '0901':
          ogTitle = '八方雲集 - 利害關係人 Stakeholders';
          ogDescription = '了解八方雲集如何與利害關係人溝通互動,包含員工、客戶、供應商、社區等各方利益關係者。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": `${baseUrl}/ESG/0901#webpage`,
            "url": `${baseUrl}/ESG/0901`,
            "name": "利害關係人｜企業永續｜八方雲集",
            "description": "八方雲集說明主要利害關係人（員工、加盟主、供應商、消費者、主管機關、投資人及社區居民），並揭露溝通管道、利害關係人問卷及員工與投資人聯絡方式，作為推動公司治理與永續發展的重要基礎。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "about": {
              "@id": `${baseUrl}/#organization`
            },
            "mainEntity": {
              "@type": "Organization",
              "@id": `${baseUrl}/#organization`,
              "name": "八方雲集",
              "contactPoint": [
                {
                  "@type": "ContactPoint",
                  "contactType": "employee relations",
                  "description": "員工申訴專線與申訴信箱",
                  "telephone": "+886-958-509-288",
                  "email": "obey.laws@8ways.com.tw",
                  "areaServed": "TW",
                  "availableLanguage": ["zh-TW"]
                },
                {
                  "@type": "ContactPoint",
                  "contactType": "customer service",
                  "description": "消費者、加盟主、社區居民、供應商等對外客服窗口",
                  "telephone": "0800-898-000",
                  "areaServed": "TW",
                  "availableLanguage": ["zh-TW"]
                },
                {
                  "@type": "ContactPoint",
                  "contactType": "investor relations",
                  "description": "投資人與股東聯絡窗口（發言人與代理發言人）",
                  "telephone": "+886-2-8809-8898",
                  "email": "IR@8way.com.tw",
                  "areaServed": "TW",
                  "availableLanguage": ["zh-TW"]
                }
              ]
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "企業永續",
                  "item": `${baseUrl}/ESG`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "利害關係人",
                  "item": `${baseUrl}/ESG/0901`
                }
              ]
            }
          };
          break;
        case '0902':
          ogTitle = '八方雲集 - 永續發展 Sustainability';
          ogDescription = '探索八方雲集的永續發展策略與實踐,包含環境保護、社會責任及公司治理。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/ESG/0902#collection`,
            "url": `${baseUrl}/ESG/0902`,
            "name": "永續發展｜企業永續｜八方雲集",
            "description": "八方雲集永續發展資訊，包括永續報告書、太陽能憑證、社會公益實施情形等內容。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "企業永續",
                  "item": `${baseUrl}/ESG`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "永續發展",
                  "item": `${baseUrl}/ESG/0902`
                }
              ]
            }
          };
          break;
        case '0903':
          ogTitle = '八方雲集 - 人權政策 The Human Rights Policy';
          ogDescription = '查看八方雲集的人權政策與承諾,保障員工權益與尊嚴,創造公平工作環境。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "@id": `${baseUrl}/ESG/0903#about`,
            "url": `${baseUrl}/ESG/0903`,
            "name": "人權政策｜企業永續｜八方雲集",
            "description": "八方雲集人權政策說明，包含員工福利措施、退休制度與職工安全等內容，落實國際人權標準與勞動法規。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "about": {
              "@id": `${baseUrl}/#organization`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "企業永續",
                  "item": `${baseUrl}/ESG`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "人權政策",
                  "item": `${baseUrl}/ESG/0903`
                }
              ]
            }
          };
          break;
        case '0904':
          ogTitle = '八方雲集 - 慈善基金會 Foundation';
          ogDescription = '認識八方雲集慈善基金會的公益活動與社會回饋,共同創造美好社會。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": `${baseUrl}/ESG/0904#webpage`,
            "url": `${baseUrl}/ESG/0904`,
            "name": "慈善基金會｜企業永續｜八方雲集",
            "description": "八方雲集慈善基金會公益活動、贊助紀錄、地方公益、教育支持與社會關懷資訊。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "企業永續",
                  "item": `${baseUrl}/ESG`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "慈善基金會",
                  "item": `${baseUrl}/ESG/0904`
                }
              ]
            }
          };
          break;
        default:
          ogTitle = '八方雲集 - ESG 永續發展';
          ogDescription = '八方雲集ESG永續發展專區,包含利害關係人、永續發展、人權政策及慈善基金會資訊。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
      }

      return {
        title: ogTitle,
        meta: [
          { property: 'og:title', content: ogTitle },
          { property: 'og:description', content: ogDescription },
          { property: 'og:image', content:'https://www.8way.com.tw/assets/images/ogImg_home.jpg'},
          { property: 'og:url', content: `${baseUrl}/ESG/${id}` },
          { property: 'og:type', content: 'website' }
        ],
        script: schemaData ? [
          {
            type: 'application/ld+json',
            json: schemaData
          }
        ] : []
      }
    },
    data () {
      return {
        name:'',
        nameEN:'',
        paramId: '',
        typeList: [],
        ESGListList: [],
        bannerImage: '',
        refname:'top1',
        menuList: [

        ],
        locale:'tw'
      }
    },
    mounted () {
      this.locale=sessionStorage.getItem('lang');
      this.paramId = this.$route.params.ids;
      this.GetTypeList();
      this.locale=sessionStorage.getItem('lang')
      if(this.$route.params.id){
        this.linktop(this.$route.params.id)
      }
      this.$nextTick(()=>{
        this.initSwiper();
      })
    },
    methods:{
      linktop(refid){
        const { top } = $(`#${refid}`).offset();
        $('html , body').animate({scrollTop: top}, 'slow');
        //document.documentElement.scrollTop = this.$refs[refid].offsetTop
        this.refname = refid
      },
      tabtitle(id, name, img, nameEN){
        this.$router.push({ name: 'ESG', params: { ids: id }});
        this.paramId = id;
        this.name = name;
        this.bannerImage = img;
        this.nameEN = nameEN;
        this.GetTypeList();
      },
      changeType(e){
        const [ choose ] = this.typeList.filter((item) => { return this.paramId === item.id });
        this.tabtitle(choose.id, choose.name, choose.bannerImage, choose.nameEN);
      },
      GetTypeList:function(){
        this.$fetch(API.getESGType).then((response) => {
          if(response.code === 200){
            this.typeList = response.data;
            if(this.paramId){
              this.typeList.forEach(item => {
                if(this.paramId === item.id){
                  this.name = item.name;
                  this.nameEN = item.nameEN;
                  this.bannerImage = item.bannerImage;
                }
              })
            }else {
              const [ type = {} ] = this.typeList;
              this.paramId = type.id;
              this.name = type.name;
              this.bannerImage = type.bannerImage;
              this.nameEN = type.nameEN;
            }
            this.GetESGList();
          }
        });
      },
      GetESGList:function(){
        this.$post(API.getESGList,{
          "typeId": this.paramId
        }).then((response) => {
          if(response.code === 200){
            this.ESGList = response.data;
          }
        });
      },
      toDetail: function (id){
        this.$router.push({ name: 'ESTDetails', params: { id: id }});
      }
    },
    watch: {
      $route: {
        handler() {
          this.paramId = this.$route.params.ids;
          this.GetTypeList();
        },
        deep: true,
      }
    },
    components:{
      'vue-tab-select': vueTabSelect
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul{
    padding-left:0;
  }
  .product{
    width: 100%;
    height:auto;
    background:#fafafa;
 /*  .top-img{
     width: 100%;
     height: 354px;
     position: relative;
     background:#fafafa url("../assets/images/product-banner.png") no-repeat top;
     background-size: 100% 100%;;
     .bg-img{
       position: absolute;
       width: 100%;
     }
     img{
      !* width: 100%;
       height: 100%;
       background-size: cover;*!
     }
     .info-box{
       width: 100%;
       max-width: 1392px;
       padding: 0 20px 0 9.339%;
       margin: 0 auto;
       &:after{
         content: "";
         display: block;
         clear: both;
       }
       .title-box{
         max-width: 54%;
         float: left;
         padding-top: 60px;
         text-align: right;
         h2{
           color: #FFFFFF;
           font-size: 68px;
           font-style: italic;
           font-weight: 900;
           letter-spacing: 0;
           line-height: 75px;
           margin-bottom: 15px;
         }
         h3{
           color: #FFFFFF;
           font-size: 36px;
           letter-spacing: 1px;
           line-height: 42px;
           margin: 0;
         }
       }
       .bannerImage{
         float: right;
         width: 46%;
         padding-top: 25px;
         img{
           width: 100%;
         }
       }
     }
   }*/


  .bannerImage{
    width: 30%;
 /*   padding-top: 25px;
    float: right;*/
    position: absolute;
    right:15%;
    bottom:-5px;
       img{
         width: 100%;
       }
  }

  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-contenBg.png") no-repeat center 100px;
    background-size: 100% auto;
    overflow: hidden;
    padding-top: 36px;
    padding-bottom: 140px;
  }
   .product-conten{
     max-width:1390px;
     padding: 0 20px;
     margin: 0 auto;
    .product-title{
      padding-bottom:40px;
      font-size: 14px;
      letter-spacing: 1.5px;
      text-align: left;
       a{
         color: #000;
         text-decoration: underline;
       }
      em{
        padding: 0 4px;
      }
      span,em{
        color: #9A928D;
      }
    }
    .nav{
      height: auto;
      width: 350px;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      padding:55px 48px 55px 44px;
      position: relative;
      float: left;
      h4,ul{
       width: 100%;
      }
      h4{
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2.1px;
        padding-bottom:8px;
      &.en-font-28{
         letter-spacing: 0px;
         font-family: 'Roboto Medium';
       }
      }
      a{
        color: #000;
        font-size: 18px;
        letter-spacing: 1.35px;
        cursor: pointer;
        display: block;
        &.active{
            color:red
          }
        &.en-font-18{
           letter-spacing: 0px;

         }
      }
     ul{
       li{
         padding: 25px 0;
         border-bottom:1px solid #e2e2e2;
         position: relative;
       }
     }
    .active{
      color: #CF0902;
      font-weight: 500;
      a{
        color: #CF0902;
      }
      .nav-line{
        height: 5px;
        width: 46px;
        display: inline-block;
        background-color: #CF0902;
        position: absolute;
        right: -63px;
        top: 36px;
      }
    }
      li:hover{
        color: #CF0902;
        font-weight: 500;
        a{
          color: #CF0902;
        }
      }
    }

   }

    .product-show {
      width: calc(100% - 350px);
      height: auto;
      float: left;
      padding-left: 124px;

      .left{
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 10px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 38px 15px 15px 15px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
      ul {
        padding-left: 0;

        li {
          width: calc( (100% - 180px ) / 3);
          float: left;
          cursor: pointer;
          margin: 0 36px 50px;
          .img-box{
            position: relative;
          }
          .big-img-box {
            width: 100%;
            border-radius: 50%;
            border: 8px solid #fff;
            overflow: hidden;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img {
              width: 100%;
              height: 100%;
              background-size: 100%;
            }
          }
          .small-img-box{
            width: 66px;
            height: 66px;
            border: solid 3px #fff;
            border-radius: 50%;
            overflow: hidden;
            background: #fff;
            position: absolute;
            right: 0;
            bottom: 19px;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img{
              width: 100%;
            }
          }

          p {
            text-align: center;
            padding-top: 10px;
            font-size: 18px;
            letter-spacing: 0.9px;
            line-height: 42px;
            color: #000;
          }
          &:nth-child(3n + 1){
            clear: both;
          }
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
    }
  }
  @media (max-width:1080px){
    .type-nav{
      margin-top: 10px;
    }
    .product{
      .product-main{
        background-image: url("../assets/images/product-bg-mobile.png");
      }
      .top-img{
        height: 187px;
        background-image: url("../assets/images/product-banner-mobile.png");
        background-size: 100% auto;
        background-color: #f9f9f9;
        background-repeat: no-repeat;
        .info-box{
          position: relative;
          height: 100%;
          .title-box{
            padding-top: 20px;
            position: static;
            float: left;
            h2{
              font-size: 24px;
              letter-spacing: 0;
              line-height: 28px;
              margin-bottom: 9px;

            }
            h3{
              font-size: 20px;
              letter-spacing: 0.56px;
              line-height: 28px;
            }
          }
          .bannerImage{
            width: auto;
            height: 66%;
            position: absolute;
            bottom: 12px;
            right: 20px;
            text-align: right;
            img{
              width: auto;
              height: 100%;
            }
          }
        }
      }
       .product-main{
         padding:0 20px;
         padding-top: 20px;

       }
       .product-conten{
         padding: 0;
         .product-title{
           padding-bottom: 20px;
         }
       }

     .product-show{
       width: 100%;
       padding: 30px 0;
       ul{
         padding: 0 5px;
         li{
           width: 50%;
           padding: 0 25px;
           margin: 0 0 25px 0;
           .img-box{
             margin-bottom: 2px;
           }
           .big-img-box{
             border-width: 5px;
             width: 100%;
             margin: 0;
           }
           p{
             font-size: 15px;
             letter-spacing: 0.5px;
             line-height: 28px;
             padding-top: 0;
           }
           &:nth-child(3n+1) {
             clear: inherit;
           }
           &:nth-child(2n+1) {
             clear: both;
           }
         }
       }
     }
    }
  }
  .table-bordered{

width:100%;
color: #2A1C15;
font-size: 18px;
line-height: 32px;
text-align: justify;
letter-spacing: 1px;


}
    .about-box-01{
    width: 100%;
    height: auto;
    overflow: hidden;
    .titleBox {
      h2{
        margin-bottom: 13px;
      }
    }
    .left{
      width: 51.3888%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 126px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 58px 75px 63px 78px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
    .right{
      width: 43.6805%;
      display: inline-block;
      vertical-align: top;
      padding: 57px 32px 0 38px;
      &.pc_hide{
        display: none;
      }
      .img{
        max-width: 560px;
        height: auto;
        img{
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }




  .dotted-box{
       .dotted-line{
        border-bottom: 1px dashed #979797;
        padding-top:6px;
        padding-bottom:6px;
         span{
           color: #000000;
           font-size: 18px;
           font-family: "Roboto Medium Italic";
           line-height: 21px;
           letter-spacing: 0.9px;
         }
         }
         }

</style>



// WEBPACK FOOTER //
// src/components/ESG.vue